import "./src/css/index.scss";
